import { SET_TEST_MODE } from "../actions/types";

const initialState = {
  testMode: false,
};

export default function adminReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_TEST_MODE:
      return {
        ...state,
        testMode: payload,
      };
    default:
      return state;
  }
}
